import React from "react";
import {TextField} from "@mui/material";
import {SelectField} from "@atttomyx/react-components";
import {forms, objects, strings} from "@atttomyx/shared-utils";
import {sortingUtils} from "../../utils";
import {ANSWER_TYPE_DOUBLE, ANSWER_TYPE_INTEGER, ANSWER_TYPE_SIGNATURE, ANSWER_TYPES} from "../../constants";

const QuestionForm = (props) => {
    const { data, onChange : onSync } = props;

    const onChange = (field, value) => {
        const modified = objects.deepCopy(data);

        modified[field] = value;

        if (field === "type" && value === ANSWER_TYPE_SIGNATURE) {
            if (value === ANSWER_TYPE_SIGNATURE) {
                modified.ask = "Signature:";

            } else if (value !== ANSWER_TYPE_INTEGER && value !== ANSWER_TYPE_DOUBLE) {
                modified.min = null;
                modified.max = null;
            }
        }

        modified.valid = strings.isNotBlank(modified.ask) && strings.isNotBlank(modified.type) && sortingUtils.isSortable(modified.order);

        onSync(modified);
    };

    return <div className="questionnaire-form">
        {data.type !== ANSWER_TYPE_SIGNATURE ?
            <div className="field">
                <TextField
                    required={true}
                    label="Ask"
                    type="text"
                    value={forms.sanitizeValue(data.ask)}
                    onChange={(event) => onChange("ask", event.target.value)}
                />
            </div> : null}
        <div className="field">
            <SelectField
                required={true}
                label="Type"
                value={forms.sanitizeValue(data.type)}
                onChange={(value) => onChange("type", value)}
                options={ANSWER_TYPES}
            />
        </div>
        {data.type === ANSWER_TYPE_INTEGER || data.type === ANSWER_TYPE_DOUBLE ?
            <>
                <div className="field">
                    <TextField
                        required={true}
                        label="Min"
                        type="number"
                        value={forms.sanitizeValue(data.min)}
                        onChange={(event) => onChange("min", event.target.value)}
                        inputProps={{
                            step: 1,
                        }}
                    />
                </div>
                <div className="field">
                    <TextField
                        required={true}
                        label="Max"
                        type="number"
                        value={forms.sanitizeValue(data.max)}
                        onChange={(event) => onChange("max", event.target.value)}
                        inputProps={{
                            step: 1,
                        }}
                    />
                </div>
            </> : null}
        <div className="field">
            <TextField
                required={true}
                label="Index"
                type="number"
                value={forms.sanitizeValue(data.order)}
                onChange={(event) => onChange("order", event.target.value)}
                inputProps={{
                    step: 1,
                    min: 0,
                }}
            />
        </div>
    </div>
}

export default QuestionForm;
